import { useLoggedOutCategoryPageBannersResponse } from "@faire/retailer-visitor-shared/components/Banners/DataFetching/useLoggedOutCategoryPageBannersResponse";
import { LoggedOutCategoryResultsBanner } from "@faire/retailer-visitor-shared/components/Banners/LoggedOutCategoryBanners/LoggedOutCategoryResultsBanner";
import { FilterPillTile } from "@faire/retailer-visitor-shared/components/FilterPillTile/FilterPillTile";
import { BuilderProductGridInlineBanner } from "@faire/retailer-visitor-shared/components/SignUpProductGridBanner/BuilderProductGridInlineBanner";
import { IBannerData } from "@faire/retailer-visitor-shared/lib/bannerUtils";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { useLoggedOutCategoryPageCurrentCategory } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/Context/useLoggedOutCategoryPageCurrentCategory";
import { trackRetailersPillWithHighlightLowMinClick } from "@faire/web-api--source/events/retailers/click/pillWithHighlightLowMin";
import { IFilterSection } from "@faire/web-api--source/indigofair/data/IFilterSection";
import React from "react";
import styled, { css } from "styled-components";

interface IProps {
  banners: IBannerData<LoggedOutCategoryResultsBanner>[];
}

export const LoggedOutCategoryBanners: React.FC<IProps> = ({ banners }) => {
  const category = useLoggedOutCategoryPageCurrentCategory();
  const { bannersResponse } = useLoggedOutCategoryPageBannersResponse();
  const renderFilterPillTile = () => {
    if (!category) {
      return null;
    }
    const brandValueFilterOptions =
      bannersResponse?.filter_pill_banner?.brand_value_filter_options ?? [];
    return (
      <FilterPillTile
        currentCategoryModel={category}
        brandValueFilterSection={IFilterSection.build({
          options: brandValueFilterOptions,
        })}
        onClick={(filter) => {
          trackRetailersPillWithHighlightLowMinClick(filter, "false");
        }}
      />
    );
  };

  const renderBanner = (
    banner: IBannerData<LoggedOutCategoryResultsBanner>
  ) => {
    switch (banner.type) {
      case LoggedOutCategoryResultsBanner.FILTER_PILL_TILE:
        return renderFilterPillTile();
      case LoggedOutCategoryResultsBanner.SIGN_UP_PRODUCT_GRID_BANNER:
        if (bannersResponse?.sign_up_product_grid_banner) {
          return <BuilderProductGridInlineBanner />;
        } else {
          return null;
        }

      default:
        return null;
    }
  };

  return (
    <>
      {banners.map((banner, index) => {
        const renderedBanner = renderBanner(banner);
        if (!renderedBanner) {
          return null;
        }
        return (
          <BannerTileWrapper
            $bannerData={banner}
            key={`logout-inline-elements-${index}`}
          >
            {renderedBanner}
          </BannerTileWrapper>
        );
      })}
    </>
  );
};

const BannerTileWrapper = styled.div<{
  $bannerData: IBannerData<LoggedOutCategoryResultsBanner>;
}>`
  ${(props) => css`
    grid-column: ${props.$bannerData.fullRowBanner
      ? "start/end"
      : css`
          ${props.$bannerData.column} / span ${props.$bannerData.size}
        `};
    grid-row: ${props.$bannerData.row} / span 1;
  `}
`;
